import { render, staticRenderFns } from "./SuspendItem.vue?vue&type=template&id=758b0725"
import script from "./SuspendItem.vue?vue&type=script&lang=js"
export * from "./SuspendItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports